class CompareContainer extends HTMLElement {
  connectedCallback() {
    this.maxItems = window.innerWidth < 750 ? 3 : 4;
    this.list = this.querySelector('.compare-list');
    this.header = document.getElementById('CompareDrawerHeading');
    this.collectionHandle = this.dataset.collectionHandle || 'default';
    this.dataCache = {};

    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.remove-from-compare');
      if (btn) {
        e.preventDefault();
        const id = btn.dataset.variantId;
        if (id) this.remove(id);
      }
    });

    document.addEventListener('compare-updated', (e) => {
      if (e.detail.handle !== this.collectionHandle) return;
      this.updateHeader(e.detail.items.length);
      if (this.isOpen()) this.update(e.detail.items);
    });

    window.addEventListener('storage', (e) => {
      if (e.key === 'compareItems' && this.isOpen()) {
        const items = this.getItems();
        this.updateHeader(items.length);
        this.update(items);
      }
    });

    window.addEventListener('resize', () => {
      if (this.isOpen()) this.matchRowHeights();
    });

    this.updateHeader(this.getItems().length);
  }

  isOpen() {
    const drawer = this.closest('drawer-component');
    return drawer && drawer.classList.contains('active');
  }

  getItems() {
    try {
      const data = JSON.parse(sessionStorage.getItem('compareItems'));
      if (Array.isArray(data)) return data;
      const all = data || {};
      return all[this.collectionHandle] || [];
    } catch (err) {
      return [];
    }
  }

  saveItems(items) {
    let all;
    try {
      const data = JSON.parse(sessionStorage.getItem('compareItems'));
      all = Array.isArray(data) ? {} : data || {};
    } catch (err) {
      all = {};
    }
    all[this.collectionHandle] = items;
    sessionStorage.setItem('compareItems', JSON.stringify(all));
  }

  async fetchData(item) {
    if (this.dataCache[item.id]) return this.dataCache[item.id];
    try {
      const url = new URL(item.url, window.location.origin);
      url.searchParams.set('view', 'compare');
      url.searchParams.set('variant', item.id);
      const res = await fetch(url);
      const text = await res.text();
      this.dataCache[item.id] = text;
      return text;
    } catch (err) {
      return null;
    }
  }

  async update(items = this.getItems()) {
    if (!this.list) return;

    const token = (this.updateToken = Symbol());

    this.classList.add('loading');
    this.list.innerHTML = '';
    const entries = items.slice(0, this.maxItems);

    // Remove old count classes
    this.list.classList.forEach((cls) => {
      if (cls.startsWith('compare-list--')) this.list.classList.remove(cls);
    });
    // Add class reflecting number of actual items
    this.list.classList.add(`compare-list--${entries.length}`);

    const results = await Promise.all(entries.map((item) => this.fetchData(item)));
    if (this.updateToken !== token) return;

    entries.forEach((item, idx) => {
      const data = results[idx];
      const div = document.createElement('div');
      div.className = 'compare-item';
      if (data) {
        div.innerHTML = data;
      } else {
        div.textContent = `Variant ${item.id}`;
      }
      this.list.appendChild(div);
    });

    if (this.updateToken !== token) return;

    for (let i = entries.length; i < this.maxItems; i++) {
      const placeholder = document.createElement('div');
      placeholder.className = 'compare-item placeholder';
      this.list.appendChild(placeholder);
    }

    this.matchRowHeights();
    this.classList.remove('loading');
  }

  matchRowHeights() {
    const items = Array.from(this.list.querySelectorAll('.compare-item'));
    if (!items.length) return;

    const rows = items[0].querySelectorAll('.compare-item--item-row');
    const rowCount = rows.length;

    // Reset previous heights
    items.forEach((item) => {
      item
        .querySelectorAll('.compare-item--item-row')
        .forEach((row) => (row.style.height = ''));
      const card = item.querySelector('.card-wrapper');
      if (card) card.style.height = '';
    });

    // Determine maximum card height
    let maxCardHeight = 0;
    items.forEach((item) => {
      const card = item.querySelector('.card-wrapper');
      if (card) {
        const h = card.getBoundingClientRect().height;
        if (h > maxCardHeight) maxCardHeight = h;
      }
    });
    // Apply maximum card height to all cards
    items.forEach((item) => {
      const card = item.querySelector('.card-wrapper');
      if (card) card.style.height = `${maxCardHeight}px`;
    });

    for (let i = 0; i < rowCount; i++) {
      let max = 0;
      items.forEach((item) => {
        const row = item.querySelectorAll('.compare-item--item-row')[i];
        if (row) {
          const h = row.getBoundingClientRect().height;
          if (h > max) max = h;
        }
      });
      items.forEach((item) => {
        const row = item.querySelectorAll('.compare-item--item-row')[i];
        if (row) row.style.height = `${max}px`;
      });
    }
  }

  updateHeader(count) {
    if (this.header)
      this.header.textContent = window.compareStrings.drawerTitle.replace('[count]', count);
  }

  remove(id) {
    const items = this.getItems().filter((i) => i.id !== id);
    this.saveItems(items);
    this.updateHeader(items.length);
    if (this.isOpen()) this.update(items);
    document.dispatchEvent(
      new CustomEvent('compare-updated', { detail: { items, handle: this.collectionHandle } })
    );
    if(items.length < 2) {
      this.closest('.drawer-component').querySelector('[data-drawer-close]').click();
    }
  }
}

customElements.define('compare-container', CompareContainer);
